import React, { FC } from 'react';
import dynamic from 'next/dynamic';

import { LightboxProps } from './types';
import useTimeout from '../../hooks/useTimeout';

const loader = () => import('.');

const Lightbox = dynamic(
  loader,
  {
    loading: () => <div />,
    ssr: false,
  },
);

const LazyLightbox: FC<LightboxProps> = (props) => {
  useTimeout(loader, 5000);

  return (
    <Lightbox {...props} isOpen={props.isOpen} />
  );
};

export default LazyLightbox;
